'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const variants = require('../../render/utils/variants.js');

function getCurrentTreeVariants(props, context) {
  if (variants.checkIfControllingVariants(props)) {
    var initial = props.initial,
      animate = props.animate;
    return {
      initial: initial === false || variants.isVariantLabel(initial) ? initial : undefined,
      animate: variants.isVariantLabel(animate) ? animate : undefined
    };
  }
  return props.inherit !== false ? context : {};
}

exports.getCurrentTreeVariants = getCurrentTreeVariants;
